import Swup from 'swup';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
import Alpine from 'alpinejs';

// import Alpine from '../alpine/packages/csp/dist/module.cjs'
import resize from '@alpinejs/resize'
import intersect from '@alpinejs/intersect';
import collapse from '@alpinejs/collapse';

import slider from './components/slider';
import {sliderMain} from "./components/slider";
import main from './components/main';
import {mainNavLink} from "./components/main";
import titlecycler from './components/titlecycler';
import count from './components/count';
import dropdown from './components/dropdown';
import videomodal from './components/videomodal';

import team from "./components/team";
import accordion from "./components/accordion";
import accordiongroup from "./components/accordiongroup";
import imageaccordion from "./components/imageaccordion";
import intersectEffects from "./components/intersectEffects";
import news from "./components/news";
import {latestNews} from "./components/news";
import banner from "./components/banner";
import scrollsection from "./components/scrollsection";
import footerNav from "./components/footerNav";
import parallaxElement from "./components/parallaxElement";


const swup = new Swup({
  plugins: [new SwupBodyClassPlugin()]
}); 

// Events
swup.hooks.on('content:replace', init);

Alpine.plugin(resize);
Alpine.plugin(intersect);
Alpine.plugin(collapse);

// Start Apline after swup so it works correctly
window.Alpine = Alpine;
Alpine.data('main', main)
Alpine.data('mainNavLink', mainNavLink)
Alpine.data('titlecycler', titlecycler)
Alpine.data('count', count)
Alpine.data('dropdown', dropdown)
Alpine.data('videomodal', videomodal)
Alpine.data('team', team)
Alpine.data('accordion', accordion)
Alpine.data('accordiongroup', accordiongroup)
Alpine.data('imageaccordion', imageaccordion)
Alpine.data('intersectEffects', intersectEffects)
Alpine.data('news', news)
Alpine.data('latestNews', latestNews)
Alpine.data('banner', banner)
Alpine.data('scrollsection', scrollsection)
Alpine.data('slider', slider)
Alpine.data('sliderMain', sliderMain)
Alpine.data('footerNav', footerNav)
Alpine.data('parallaxElement', parallaxElement)
Alpine.start();

document.addEventListener("DOMContentLoaded", () => init);

// Functions 
function l(m) { 
  console.log(m); 
}

// Slider
import EmblaCarousel from 'embla-carousel'
import Autoplay from 'embla-carousel-autoplay';
import ClassNames from 'embla-carousel-class-names'

import { addPrevNextBtnsClickHandlers } from './components/EmblaCarouselArrowButtons'
import { addPlayBtnListeners, addNavBtnListeners } from './components/EmblaCarouselAutoScroll'
import { addDotBtnsAndClickHandlers } from './components/EmblaCarouselDotButton'



function initEmbla() {
  if(document.querySelector('.tabs .embla')) {
    console.log('tabs embla')
    const OPTIONS = { loop: true, align: 'start' }

    const emblaNode = document.querySelector('.tabs .embla')
    const viewportNode = emblaNode.querySelector('.embla__viewport')
    const prevBtn = document.querySelector('.embla__button--prev')
    const nextBtn = document.querySelector('.embla__button--next')
    // const playBtn = document.querySelector('.embla__play')

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
      Autoplay({ playOnInit: true, delay: 3000 }),
      ClassNames()
    ])

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      emblaApi,
      prevBtn,
      nextBtn
    )
    // const removePlayBtnListeners = addPlayBtnListeners(emblaApi, playBtn)
    const removeNavBtnListeners = addNavBtnListeners(emblaApi, prevBtn, nextBtn)

    emblaApi
      .on('destroy', removePrevNextBtnsClickHandlers)
      .on('destroy', removeNavBtnListeners)
      // .on('destroy', removePlayBtnListeners)
  }

  if(document.querySelector('.gallery .embla')) {
    console.log('gallery embla')
    const OPTIONS = { loop: true, align: 'center' }

    const emblaNode = document.querySelector('.gallery .embla')
    const viewportNode = emblaNode.querySelector('.embla__viewport')
    const prevBtn = document.querySelector('.embla__button--prev')
    const nextBtn = document.querySelector('.embla__button--next')
    const dotsNode = emblaNode.querySelector('.embla__dots')

    // const playBtn = document.querySelector('.embla__play')

    const emblaApi = EmblaCarousel(viewportNode, OPTIONS, [
      Autoplay({ playOnInit: true, delay: 5000 }),
      ClassNames()
    ])

    const removePrevNextBtnsClickHandlers = addPrevNextBtnsClickHandlers(
      emblaApi,
      prevBtn,
      nextBtn
    )

    const removeDotBtnsAndClickHandlers = addDotBtnsAndClickHandlers(
      emblaApi,
      dotsNode
    )

    // const removePlayBtnListeners = addPlayBtnListeners(emblaApi, playBtn)
    const removeNavBtnListeners = addNavBtnListeners(emblaApi, prevBtn, nextBtn)

    emblaApi
      .on('destroy', removePrevNextBtnsClickHandlers)
      .on('destroy', removeNavBtnListeners)
      .on('destroy', removeDotBtnsAndClickHandlers)
      // .on('destroy', removePlayBtnListeners)
  }
}
// .Slider







function init() {
  l('👍');
  window.scroll(0,0);
  cookieNotice();
  window.dispatchEvent(new Event('navigated'))
  makeStylesSafe()
  initEmbla()
}

init()


function makeStylesSafe() {
  document.querySelectorAll("[data-style]").forEach(node => {
    const rules = node.dataset.style.split(';')
    for (const rule of rules) {
      const identifier = rule.split(':')[0]
      const value = rule.split(':')[1]
      node.style[identifier] = value
    }
  })
}


function cookieNotice() {
  l('cookienotice');
  document.querySelector('.cookie_btn').addEventListener('click', setCookie);
}

function setCookie() {
  l('set cookie');
  document.cookie = 'cookie-note=1;max-age=864000';
  document.querySelector('.cookie').classList.add('hidden');
}


